import { PERMISSIONS } from '@repo/contracts';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';

import { selectCan } from '@/store/auth.slice';
import { useAppSelector } from '@/store/store';

import { syncKeys } from './query-keys';
import { useSyncJobs } from './use-sync-jobs';

/**
 * When the last running job finishes, everything the console shows is stale at once: the
 * history, the conflicts the run may have found, and the count on the navigation badge.
 */
export const useRefreshOnRunFinish = (): void => {
  const queryClient = useQueryClient();
  const canRead = useAppSelector(selectCan(PERMISSIONS.directoryRead));
  const { data } = useSyncJobs(canRead);
  const anyRunning = data?.jobs.some((job) => job.running) ?? false;
  const wasRunning = useRef(false);

  useEffect(() => {
    if (wasRunning.current && !anyRunning) {
      void queryClient.invalidateQueries({ queryKey: syncKeys.all });
    }

    wasRunning.current = anyRunning;
  }, [anyRunning, queryClient]);
};
